import React, { useReducer } from 'react';
import { createBaseContext } from '../base';
import { reducer, initState } from './reducer';

// 实例化上下文，这里避免了为空检查
const [Context, useBaseContext] = createBaseContext();

export function useGlobalContext() {
	const globalContext = useBaseContext();
	// TODO: custom some
	return globalContext;
}

export function GlobalContext({ children = null, value }) {
	const [state, dispatch] = useReducer(reducer, value || initState);
	const getValue = key => state[key];
	const setValue = (key, value) => {
		dispatch({ type: 'SET_VALUE', key, value });
	};

	let ctx = {
		state,
		dispatch,
		getValue,
		setValue
	};

	return <Context.Provider value={ctx}>{children}</Context.Provider>;
}
